var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Main"}},[_c('div',{attrs:{"id":"fixTop"}},[_c('TopHead'),_c('TabMain')],1),_c('div',{staticClass:"main_content",style:({ paddingTop: _vm.fixTop + 'px' }),attrs:{"id":"main_content"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }